import React, { useEffect, useRef, useState } from "react";
import { getData, insertData, insertDataJson, searchTable, updateItem, baseRuta } from "../../Tools/helpers";
import Alert from "@mui/material/Alert";

import FormCustom from "../../components/FormCustom";
import TableCustom from "../../components/TableCustom";
import DialogCustom from "../../components/DialogCustom";
import { PageTitle, SearchInput } from "../../components/PageHeader";

const Student = () => {
  const [userData] = useState(JSON.parse(localStorage.getItem("USER_IUMV")));
  const isDirector = userData?.abbreviation === "director";
  const isDirectorGeneral = userData?.abbreviation === "director_general" || userData?.admin === "true";
  const canManageStudents = isDirector || isDirectorGeneral;

  const [dataTable, setDataTable] = useState([]);
  const [dataForm, setDataForm] = useState({});
  const [isTrueUpdateData, setIsTrueUpdateData] = useState(false);
  const [isTrueDeleteData, setIsTrueDeleteData] = useState(false);
  const [isBajaDialog, setIsBajaDialog] = useState(false);
  const [bajaStudent, setBajaStudent] = useState(null);

  const [listCareers, setListCareers] = useState([]);
  const [listUniversities, setListUniversities] = useState([]);
  const [listPermissions, setListPermissions] = useState([]);

  // Carga masiva
  const fileInputRef = useRef(null);
  const [bulkFile, setBulkFile] = useState(null);
  const [bulkParsing, setBulkParsing] = useState(false);
  const [bulkSaving, setBulkSaving] = useState(false);
  const [bulkPreview, setBulkPreview] = useState(null); // { valid, invalid }
  const [bulkMessage, setBulkMessage] = useState({ status: false, message: "", label: "" });
  const [bulkUniversityId, setBulkUniversityId] = useState("");

  const directorCareers = isDirector
    ? listCareers.filter((c) => String(c.university_id) === String(userData?.university_id))
    : listCareers;

  const allFields = [
    { name: "name", label: "Nombre completo", required: "true" },
    { name: "curp", label: "Curp", required: "true" },
    { name: "phone", label: "Teléfono", required: "false" },
    { name: "email", label: "Email", required: "true" },
    { name: "start_date", label: "Fecha de inicio", required: "false", type: "date" },
    {
      name: "university_id",
      label: "Campus",
      required: "true",
      type: "select",
      list: listUniversities,
      field_select_description: "name",
    },
    {
      name: "career_id",
      label: "Carrera",
      required: "true",
      type: "select",
      list: directorCareers,
      field_select_description: "name",
    },
    { name: "password", label: "Contraseña", required: "true", type: "password" },
    {
      name: "permission_id",
      label: "Permiso de usuario",
      required: "true",
      type: "select",
      list: listPermissions,
      field_select_description: "description",
    },
    {
      name: "status",
      label: "Estatus",
      required: "true",
      type: "select",
      list: [
        { 'id': 'Activo', 'status': 'Activo' },
        { 'id': 'Graduado', 'status': 'Graduado' },
        { 'id': 'Baja', 'status': 'Baja' },
      ],
      field_select_description: "status",
    },
  ];

  const FieldsCustom = isDirector
    ? allFields.filter((f) => f.name !== "university_id")
    : allFields;

  const FieldsCustomTable = [
    { name: "name", label: "Nombre completo", required: "true" },
    { name: "curp", label: "Curp", required: "true" },
    { name: "phone", label: "Teléfono", required: "false" },
    { name: "email", label: "Email", required: "true" },
    { name: "career_name", label: "Carrera", required: "true" },
    { name: "university_name", label: "Campus", required: "true" },
    { name: "status", label: "Estatus", required: "true" },
  ];

  const routeForm = "Student";

  const getStaff = async () => {
    const route = routeForm;
    const send = await getData(route);
    console.log(send);
    if (send.code === 200) {
      setDataTable(send.data);
      setListSearch(send.data);
    }
  };

    //BUSQUEDA
    const [fieldSearch, setFieldSearch] = useState("");
    const [listSearch, setListSearch] = useState([]);
  
    const setStateSearch = async (e) => {
      await setFieldSearch(e.target.value);
      const resulData = await searchTable(dataTable, e.target.value, "name", "curp", "email");
      setListSearch(resulData);
    };


  const getCareers = async () => {
    const route = "Career";
    const send = await getData(route);
    if (send.code === 200) {
      setListCareers(send.data);
    }
  };

  const getUniversities = async () => {
    const route = "University";
    const send = await getData(route);
    if (send.code === 200) {
      setListUniversities(send.data);
    }
  };

  const getPermissions = async () => {
    const route = "Permission";
    const send = await getData(route);
    if (send.code === 200) {
      const data = send.data.filter((item) => item.abbreviation === "student");
      setListPermissions(data);
    }
  };

  useEffect(() => {
    getStaff();
    getCareers();
    getPermissions();
    if (isDirector) {
      setDataForm({ university_id: userData.university_id });
    } else {
      getUniversities();
    }
  }, []);

  const handleBulkFileChange = (e) => {
    setBulkFile(e.target.files[0] || null);
    setBulkPreview(null);
    setBulkMessage({ status: false, message: "", label: "" });
  };

  const effectiveUniversityId = isDirector ? userData?.university_id : bulkUniversityId;

  const handleBulkParse = async () => {
    if (!bulkFile) return;
    if (isDirectorGeneral && !bulkUniversityId) {
      setBulkMessage({ status: true, message: "Selecciona un campus primero", label: "warning" });
      return;
    }
    setBulkParsing(true);
    setBulkMessage({ status: false, message: "", label: "" });
    const formData = new FormData();
    formData.append("file", bulkFile);
    if (effectiveUniversityId) formData.append("university_id", effectiveUniversityId);
    const send = await insertData("Student/ParseBulkUpload", formData);
    setBulkParsing(false);
    if (send.code === 200) {
      setBulkPreview({ valid: send.valid, invalid: send.invalid });
    } else {
      setBulkMessage({ status: true, message: send.message || "Error al procesar el archivo", label: "error" });
    }
  };

  const handleBulkStore = async () => {
    if (!bulkPreview?.valid?.length) return;
    setBulkSaving(true);
    const payload = { students: bulkPreview.valid };
    if (effectiveUniversityId) payload.university_id = effectiveUniversityId;
    const send = await insertDataJson("Student/BulkStore", payload);
    setBulkSaving(false);
    if (send.code === 200) {
      setBulkMessage({
        status: true,
        message: `${send.saved} alumnos guardados correctamente.${send.errors?.length ? ` ${send.errors.length} errores.` : ""}`,
        label: send.errors?.length ? "warning" : "success",
      });
      setBulkPreview(null);
      setBulkFile(null);
      setBulkUniversityId("");
      if (fileInputRef.current) fileInputRef.current.value = "";
      getStaff();
    } else {
      setBulkMessage({ status: true, message: "Error al guardar", label: "error" });
    }
  };

  useEffect(() => {
    if (isTrueDeleteData) {
      setBajaStudent(dataForm);
      setIsBajaDialog(true);
      setIsTrueDeleteData(false);
    }
  }, [isTrueDeleteData]);

  const confirmBaja = async (option) => {
    setIsBajaDialog(false);
    if (!option || !bajaStudent) return;
    const send = await updateItem(`Student/${bajaStudent.id}`, { status: 'Baja' });
    if (send.code === 200) {
      getStaff();
    }
  };

  const downloadErrorsCSV = () => {
    if (!bulkPreview?.invalid?.length) return;
    const rows = [["Fila", "Nombre", "CURP", "Carrera", "Errores"]];
    bulkPreview.invalid.forEach((r) =>
      rows.push([r.row, r.name, r.curp, r.career_name, r.errors?.join(" | ")])
    );
    const csv = rows.map((r) => r.map((c) => `"${c ?? ""}"`).join(",")).join("\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "errores_carga_masiva.csv";
    a.click();
    URL.revokeObjectURL(url);
  };

  const thStyle = {
    padding: '8px 12px', fontSize: '0.65rem', fontWeight: 700, textTransform: 'uppercase',
    letterSpacing: '0.06em', color: '#f9fafb', backgroundColor: '#111827',
    borderBottom: '2px solid #dc2626', whiteSpace: 'nowrap', textAlign: 'left',
  };
  const tdStyle = (i) => ({
    padding: '7px 12px', fontSize: '0.78rem', color: '#374151',
    borderBottom: '1px solid #f1f5f9', backgroundColor: i % 2 === 0 ? '#fff' : '#f8fafc',
  });

  return (
    <div className="flex-1">
      <DialogCustom
        open={isBajaDialog}
        message={{ title: 'Dar de baja', message: `¿Desea dar de baja a ${bajaStudent?.name}?` }}
        action={confirmBaja}
      />
      <PageTitle>Estudiantes</PageTitle>

      {canManageStudents && (
        <div style={{ backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '20px 24px', marginTop: '16px', marginBottom: '24px', maxWidth: '780px' }}>

          {/* Header */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '18px' }}>
            <div style={{ borderLeft: '4px solid #dc2626', paddingLeft: '10px' }}>
              <span style={{ fontSize: '0.78rem', fontWeight: 700, color: '#111827', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                Carga Masiva de Alumnos
              </span>
            </div>
            <button
              onClick={async () => {
                const token = localStorage.getItem("STORAGE_KEY_IUMV");
                const res = await fetch(baseRuta + "Student/BulkTemplate", {
                  headers: { Authorization: `Bearer ${token}` },
                });
                const blob = await res.blob();
                const url = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = "plantilla_alumnos.xlsx";
                a.click();
                URL.revokeObjectURL(url);
              }}
              style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '6px 12px', borderRadius: '5px', border: '1px solid #d1d5db', backgroundColor: '#fff', color: '#374151', fontSize: '0.72rem', fontWeight: 600, cursor: 'pointer' }}
            >
              <i className="fa-solid fa-download" style={{ fontSize: '10px' }}></i>
              Descargar plantilla
            </button>
          </div>

          {/* Campus selector */}
          {isDirectorGeneral && (
            <div style={{ marginBottom: '14px' }}>
              <label style={{ display: 'block', fontSize: '0.72rem', fontWeight: 600, color: '#374151', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: '5px' }}>Campus</label>
              <select
                value={bulkUniversityId}
                onChange={(e) => { setBulkUniversityId(e.target.value); setBulkPreview(null); }}
                style={{ padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '0.83rem', color: '#111827', outline: 'none', backgroundColor: '#fff', width: '100%', maxWidth: '320px' }}
              >
                <option value="">Seleccionar campus...</option>
                {listUniversities.map((u) => (
                  <option key={u.id} value={u.id}>{u.name}</option>
                ))}
              </select>
            </div>
          )}

          {/* Career keys */}
          {(() => {
            const campusCareers = isDirectorGeneral
              ? (bulkUniversityId ? listCareers.filter((c) => String(c.university_id) === String(bulkUniversityId)) : [])
              : directorCareers;
            if (!campusCareers.length) return null;
            return (
              <div style={{ marginBottom: '14px' }}>
                <div style={{ fontSize: '0.72rem', fontWeight: 600, color: '#374151', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: '6px' }}>Claves de carrera</div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                  {campusCareers.map((c) => (
                    <span key={c.id} style={{ fontSize: '0.68rem', backgroundColor: '#f1f5f9', border: '1px solid #e2e8f0', borderRadius: '4px', padding: '2px 8px', fontFamily: 'monospace', color: '#374151' }}>
                      {c.code} – {c.name}
                    </span>
                  ))}
                </div>
              </div>
            );
          })()}

          {/* File upload zone */}
          <div style={{ border: '2px dashed #d1d5db', borderRadius: '8px', padding: '16px', backgroundColor: '#fff', display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '14px' }}>
            <div style={{ width: '40px', height: '40px', borderRadius: '8px', backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <i className="fa-solid fa-file-excel" style={{ fontSize: '18px', color: '#16a34a' }}></i>
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: '0.82rem', fontWeight: 600, color: '#111827', marginBottom: '2px' }}>
                {bulkFile
                  ? <span style={{ color: '#16a34a' }}><i className="fa-solid fa-circle-check" style={{ marginRight: '5px' }}></i>{bulkFile.name}</span>
                  : 'Ningún archivo seleccionado'
                }
              </div>
              <div style={{ fontSize: '0.7rem', color: '#6b7280' }}>Formatos aceptados: .xlsx, .xls</div>
            </div>
            <label style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '7px 14px', borderRadius: '5px', border: '1px solid #374151', backgroundColor: '#111827', color: '#fff', fontSize: '0.72rem', fontWeight: 600, cursor: 'pointer', flexShrink: 0 }}>
              <i className="fa-solid fa-upload" style={{ fontSize: '10px' }}></i>
              Seleccionar archivo
              <input ref={fileInputRef} type="file" accept=".xlsx,.xls" onChange={handleBulkFileChange} style={{ display: 'none' }} />
            </label>
          </div>

          {/* Actions */}
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            <button
              onClick={handleBulkParse}
              disabled={!bulkFile || bulkParsing}
              style={{
                display: 'inline-flex', alignItems: 'center', gap: '7px',
                backgroundColor: !bulkFile || bulkParsing ? '#9ca3af' : '#111827',
                color: '#fff', border: 'none', borderRadius: '6px',
                padding: '9px 18px', fontSize: '0.78rem', fontWeight: 700,
                textTransform: 'uppercase', letterSpacing: '0.05em',
                cursor: !bulkFile || bulkParsing ? 'not-allowed' : 'pointer',
              }}
              onMouseEnter={e => { if (bulkFile && !bulkParsing) e.currentTarget.style.backgroundColor = '#dc2626'; }}
              onMouseLeave={e => { if (bulkFile && !bulkParsing) e.currentTarget.style.backgroundColor = '#111827'; }}
            >
              <i className="fa-solid fa-eye" style={{ fontSize: '11px' }}></i>
              {bulkParsing ? 'Procesando...' : 'Previsualizar'}
            </button>
          </div>

          {bulkMessage.status && <Alert className="mt-3" severity={bulkMessage.label}>{bulkMessage.message}</Alert>}

          {/* Preview */}
          {bulkPreview && (
            <div style={{ marginTop: '16px' }}>

              {/* Valid */}
              {bulkPreview.valid.length > 0 && (
                <div style={{ marginBottom: '16px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                    <span style={{ fontSize: '0.72rem', fontWeight: 700, color: '#166534', backgroundColor: '#dcfce7', padding: '2px 10px', borderRadius: '9999px' }}>
                      <i className="fa-solid fa-circle-check" style={{ marginRight: '5px' }}></i>
                      Válidos: {bulkPreview.valid.length}
                    </span>
                  </div>
                  <div style={{ overflowX: 'auto', borderRadius: '6px', border: '1px solid #e2e8f0' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          {['Nombre', 'CURP', 'Clave', 'Carrera', 'Inicio'].map(h => <th key={h} style={thStyle}>{h}</th>)}
                        </tr>
                      </thead>
                      <tbody>
                        {bulkPreview.valid.map((r, i) => (
                          <tr key={r.row}>
                            <td style={tdStyle(i)}>{r.name}</td>
                            <td style={{ ...tdStyle(i), fontFamily: 'monospace', fontSize: '0.72rem' }}>{r.curp}</td>
                            <td style={{ ...tdStyle(i), fontFamily: 'monospace' }}>{r.career_code}</td>
                            <td style={tdStyle(i)}>{r.career_name}</td>
                            <td style={tdStyle(i)}>{r.start_date}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* Invalid */}
              {bulkPreview.invalid.length > 0 && (
                <div style={{ marginBottom: '16px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                    <span style={{ fontSize: '0.72rem', fontWeight: 700, color: '#991b1b', backgroundColor: '#fee2e2', padding: '2px 10px', borderRadius: '9999px' }}>
                      <i className="fa-solid fa-circle-xmark" style={{ marginRight: '5px' }}></i>
                      Con errores: {bulkPreview.invalid.length}
                    </span>
                    <button
                      onClick={downloadErrorsCSV}
                      style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '4px 10px', borderRadius: '5px', border: '1px solid #d1d5db', backgroundColor: '#f8fafc', color: '#374151', fontSize: '0.7rem', fontWeight: 600, cursor: 'pointer' }}
                    >
                      <i className="fa-solid fa-download" style={{ fontSize: '10px' }}></i>
                      Descargar CSV errores
                    </button>
                  </div>
                  <div style={{ overflowX: 'auto', borderRadius: '6px', border: '1px solid #e2e8f0' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          {['Fila', 'Nombre', 'CURP', 'Errores'].map(h => <th key={h} style={{ ...thStyle, backgroundColor: '#7f1d1d' }}>{h}</th>)}
                        </tr>
                      </thead>
                      <tbody>
                        {bulkPreview.invalid.map((r, i) => (
                          <tr key={r.row}>
                            <td style={{ ...tdStyle(i), fontWeight: 700 }}>{r.row}</td>
                            <td style={tdStyle(i)}>{r.name}</td>
                            <td style={{ ...tdStyle(i), fontFamily: 'monospace', fontSize: '0.72rem' }}>{r.curp}</td>
                            <td style={{ ...tdStyle(i), color: '#dc2626', fontSize: '0.72rem' }}>{r.errors?.join(', ')}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* Confirm save */}
              {bulkPreview.valid.length > 0 && (
                <button
                  onClick={handleBulkStore}
                  disabled={bulkSaving}
                  style={{
                    display: 'inline-flex', alignItems: 'center', gap: '7px',
                    backgroundColor: bulkSaving ? '#9ca3af' : '#15803d',
                    color: '#fff', border: 'none', borderRadius: '6px',
                    padding: '9px 18px', fontSize: '0.78rem', fontWeight: 700,
                    textTransform: 'uppercase', letterSpacing: '0.05em',
                    cursor: bulkSaving ? 'not-allowed' : 'pointer',
                  }}
                  onMouseEnter={e => { if (!bulkSaving) e.currentTarget.style.backgroundColor = '#166534'; }}
                  onMouseLeave={e => { if (!bulkSaving) e.currentTarget.style.backgroundColor = '#15803d'; }}
                >
                  <i className="fa-solid fa-floppy-disk" style={{ fontSize: '11px' }}></i>
                  {bulkSaving ? 'Guardando...' : `Confirmar y guardar ${bulkPreview.valid.length} alumnos`}
                </button>
              )}
            </div>
          )}
        </div>
      )}

      <div className="mb-4 max-w-2xl">
        <FormCustom
          fields={FieldsCustom}
          title="DATOS DE ESTUDIANTES"
          route={routeForm}
          method="post"
          setData={setDataForm}
          data={dataForm}
          fieldDialog="name"
          setIsTrueUpdateData={setIsTrueUpdateData}
          isTrueUpdateData={isTrueUpdateData}
          refreshDataList={getStaff}
          setIsTrueDeleteData={() => {}}
          isTrueDeleteData={false}
        />
      </div>

      <div className="flex-1">
        <div style={{ marginBottom: '16px' }}>
          <SearchInput
            value={fieldSearch}
            onChange={setStateSearch}
            placeholder="Buscar por nombre, curp o correo..."
          />
        </div>
        <TableCustom
          fields={FieldsCustomTable}
          setDataForm={setDataForm}
          data={listSearch}
          setIsTrueUpdateData={setIsTrueUpdateData}
          setIsTrueDeleteData={setIsTrueDeleteData}
          deleteLabel="Baja"
        />
      </div>
    </div>
  );
};

export default Student;
